module.exports = __webpack_public_path__ + "static/giphy-5211f834f862cbd98e7429feea3a3aa8.gif";